<!--  -->
<template>
  <div class="Home">

    <header>
      <Row type="flex" align="middle" style="height:88px">

        <Col span="9">
        <div style="display:flex;width:100%;align-items:center;justify-content:center;font-size:18px;font-weight: 500;">

          <img src="../../assets/images/B_user/title.png" alt="" style="width:211px;display:block;">

          <span style="margin:0 10px">|</span>
          <span>企业端</span>
        </div>
        </Col>

        <Col span="6" class="tabs">
        <ul>
          <li style="cursor: pointer;" v-for="(item, index) in tabs" :key="index" @click="go(item.path)">{{ item.name }}
          </li>
        </ul>
        </Col>

        <Col span="9">
        <div>
          <Button type="error" @click="$router.push({ name: 'Register' })">我要招聘</Button>

          <Poptip style="margin-left:50px;color:#333333;cursor:pointer;" trigger="hover">
            <p>手机端</p>
            <div slot="content" style="display:flex;align-items:center;padding:20px">
              <div style="margin-right:15px">
                <img style="width: 100px;" src="../../assets/images/img2.png" alt="">
                <p style="text-align:center">小程序</p>
              </div>
              <div style="margin-left:15px">
                <img style="width: 100px;" src="../../assets/images/img1.png" alt="">
                <p style="text-align:center">公众号</p>
              </div>

            </div>
          </Poptip>

        </div>
        </Col>

      </Row>
    </header>
    <div class="bak">
      <div class="back_img">
        <img src="@/assets/images/B_user/Main@2x.png" alt="">
        <!-- 图片 -->
      </div>
      <div class="login_box">

        <div class="top">
          <p style="font-size:28px;font-weight:Bold">登录企业账户</p>
          <div style="margin-top:8px;">
            <p>没有账户？</p>
            <p style="color:#FC4455;cursor:pointer;" @click="$router.push({ name: 'Register' })">免费注册</p>
            <div>
              <img src="@/assets/images/B_user/login_right.png" alt="">
            </div>
          </div>
        </div>

        <div class="content">
          <Tabs :animated="false" v-model="Tabs">
            <TabPane label="短信登录" name='1'>
              <Input v-model="mobile">
              <span slot="prepend">手机号</span>
              </Input>

              <Input v-model="authcode" style="margin:20px 0">
              <span slot="prepend">验证码</span>
              <Button slot="append" type="text" @click="get_authcode" :loading="loading"
                :disabled='disabled'>{{ text }}</Button>
              </Input>

            </TabPane>
            <TabPane label="密码登录" name='2'>
              <Input v-model.trim="Account">
              <span slot="prepend">账&nbsp;&nbsp;&nbsp;号</span>
              </Input>

              <Input v-model="password" style="margin:20px 0" password type="password">
              <span slot="prepend">密&nbsp;&nbsp;&nbsp;码</span>
              </Input>

            </TabPane>
          </Tabs>
          <Checkbox v-model="single">我已阅读并同意</Checkbox>
          <span style="color:#009DFF;cursor:pointer;" @click="agreement">《用户协议》</span>
          <span>和</span>
          <span style="color:#009DFF;cursor:pointer;" @click="privacy">《隐私政策》</span>
        </div>
        <div class="bottom">
          <Button type="error" style="background:#FC4455" size="large" long @click="login"
            :loading="loading_login">立即登录</Button>
          <p @click="$router.push({ name: 'forgetPassword' })">忘记密码?</p>
        </div>

      </div>

    </div>
    <router-view></router-view>

    <footer>
      <div class="left">
        <ul>
          <li>
            <span class="title">企业服务热线：</span>
            <span>400-00-51945</span>
          </li>
          <li>
            <span class="title">公司邮箱：</span>
            <span>zhao9wan4@163.com</span>
          </li>
          <li>
            <span class="title">公司地址：</span>
            <span>广东省广州市黄埔区云埔街春晖一街102号</span>
          </li>
          <li>
            <span class="title">网络备案号：</span>
            <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2021090037号-1</a>
          </li>
        </ul>
      </div>
      <div class="right">

        <img style="margin-right: 30px;" src="../../assets/images/img1.png" alt="">

        <img src="../../assets/images/img2.png" alt="">

      </div>
    </footer>

  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: [
        {
          name: '首页',
          path: 'home_page'
        },
        {
          name: '关于我们',
          path: 'about_Us',
        },
        {
          name: '相关资讯',
          path: 'message',
        },
        {
          name: '联系我们',
          path: 'contact_us',
        },

      ],
      //登录数据
      loading_login: false,
      loading: false,
      disabled: false,
      text: '获取验证码',
      Tabs: "2",
      //手机号
      mobile: "",
      // 验证码
      authcode: "",
      //账号
      Account: "",
      //密码
      password: "",
      single: false,
    }
  },
  methods: {
    go(path) {
      this.$router.push({ name: path })
    },
    //协议
    agreement() {
      this.$router.push({ name: "agreement" })
    },
    //隐私
    privacy() {
      this.$router.push({ name: "privacy" })
    },
    //获取验证码
    get_authcode() {
      //验证手机号格式
      if (/^1[3-9][0-9]{9}$/.test(this.mobile)) {
        //验证手机号是否已注册
        this.loading = true
        this.app('enterpriseOperators', 'checkRegisterMobile', { mobile: this.mobile }).then(res => {
          if (res.data.mobileRegisted) {
            //已被注册可以发送验证码
            this.app('enterpriseOperators', 'sendRegisterCode', { mobile: this.mobile }).then(res => {
              this.loading = false
              this.disabled = true
              this.text = '60'
              let clock = setInterval(() => {
                if (this.text) {
                  this.text--
                } else {
                  this.text = '获取验证码'
                  clearInterval(clock)
                  this.disabled = false
                }
              }, 1000);
            })
          } else {
            this.loading = false
            this.$Modal.warning({
              title: "您还未注册，请先注册再登录！",
              onOk: () => {
                this.$router.push('Register')
              },
              closable: true
            })
          }
        })
      } else {
        this.$Modal.warning({
          title: "手机号码格式不正确"
        })
      }
    },
    login() {
      //验证勾选协议
      if (this.single) {
        //验证码登录
        if (this.Tabs == 1) {
          //验证手机号及验证码格式
          if (/^1[3-9][0-9]{9}$/.test(this.mobile) && /^[0-9]{6}$/.test(this.authcode)) {
            //手机号及验证码都填写完毕
            this.loading_login = true
            this.app('enterpriseOperators', 'checkCode', {
              mobile: this.mobile,
              code: this.authcode
            }).then(res => {
              if (res.code == 200) {

                localStorage.setItem('firm_mobile', this.mobile)
                localStorage.setItem('firm_token', res.data.token)
                localStorage.setItem('firm_enterpriseId', res.data.enterpriseId)
                localStorage.setItem('firm_check', 1)

                this.$router.push('B_Home')
                this.loading_login = false
              } else {
                this.$Modal.warning({
                  title: res.message
                })
                this.loading_login = false
              }
            })
          } else {
            this.$Modal.warning({
              title: "手机号码或验证码格式不正确"
            })
          }

        } else {
          //账号密码登录
          if (this.Account && this.password) {
            this.loading_login = true
            this.app('enterpriseOperators', 'login', {
              mobile: this.Account,
              password: this.password
            }).then(res => {

              this.loading_login = false
              if (res.code == 200) {

                localStorage.setItem('firm_mobile', this.Account)
                localStorage.setItem('firm_token', res.data.token)
                localStorage.setItem('firm_enterpriseId', res.employee.enterpriseId)
                //记录勾选
                localStorage.setItem('firm_check', 1)
                //储存账号及密码
                localStorage.setItem('firm_account', this.Account)
                localStorage.setItem('firm_password', this.password)

                this.$router.push('B_Home')

              }
              // else {
              //   this.$Modal.warning({
              //     title: res.message
              //   })
              //   this.loading_login = false
              // }
            })
          } else {
            this.$Modal.warning({
              title: "账号或密码不能为空"
            })
          }
        }
      } else {
        this.$Modal.warning({
          title: "请阅读并同意《用户协议》和《隐私政策》"
        })
      }
    },
  },

  created() {
    if (localStorage.getItem('firm_account')) {
      this.Account = localStorage.getItem('firm_account')
      this.password = localStorage.getItem('firm_password')
    }
    if (localStorage.getItem('firm_check')) {
      this.single = true
    }
  }
}
</script>

<style lang="less" scoped>
@import "./Home.less";
</style>
